import React from 'react';
import type { TimesheetCellValue, CellCapacityInfo } from '../../types/timesheet.types';
import { formatHours } from '../../utils/timesheet-capacity';

export interface TimesheetCellProps {
  /** Cell value (actual + planned hours) */
  value: TimesheetCellValue | undefined;
  /** Pre-computed capacity info for this cell (null for non-user rows or missing data) */
  capInfo: CellCapacityInfo | null;
  /** Whether this column is a weekend */
  isWeekendColumn?: boolean;
  /** Click handler */
  onClick?: () => void;
}

const TimesheetCell: React.FC<TimesheetCellProps> = ({
  value,
  capInfo,
  isWeekendColumn,
  onClick,
}) => {
  const actual = value?.actual ?? 0;
  const hasData = actual > 0;

  // Determine cell CSS class based on status
  let statusClass = '';
  if (capInfo) {
    switch (capInfo.status) {
      case 'over':
        statusClass = 'rp-ts-cell--over';
        break;
      case 'at_capacity':
        statusClass = 'rp-ts-cell--at-capacity';
        break;
      case 'normal':
        statusClass = hasData ? 'rp-ts-cell--normal' : '';
        break;
      case 'holiday':
        statusClass = 'rp-ts-cell--holiday';
        break;
      case 'weekend':
        statusClass = 'rp-ts-cell--weekend';
        break;
      case 'leave':
        statusClass = 'rp-ts-cell--leave';
        break;
      default:
        break;
    }
  }

  const weekendClass = isWeekendColumn ? 'rp-ts-cell--weekend-col' : '';
  const clickableClass = hasData && onClick ? 'rp-ts-cell--clickable' : '';

  return (
    <td
      className={`rp-ts-cell ${statusClass} ${weekendClass} ${clickableClass}`.trim()}
      onClick={hasData ? onClick : undefined}
      title={
        capInfo && hasData
          ? `Logged: ${formatHours(actual)} / Capacity: ${formatHours(capInfo.availableHours)}`
          : undefined
      }
    >
      <span className={hasData ? 'rp-ts-cell__value' : 'rp-ts-cell__empty'}>
        {formatHours(actual)}
      </span>
    </td>
  );
};

export default React.memo(TimesheetCell);
